import React from "react";
import { Link } from "react-router-dom"; // or 'next/link' for Next.js
import "./Button.css";

const Button = ({
                    text,
                    link,
                    onClick,
                    type = "primary", // color theme
                    size = "medium",  // small | medium | large
                    disabled = false,
                    leftIcon,
                    rightIcon,
                }) => {
    const className = `btn btn-${type} btn-${size} ${disabled ? "btn-disabled" : ""}`;

    const content = (
        <>
            {leftIcon && <span className="btn-icon left">{leftIcon}</span>}
            {text}
            {rightIcon && <span className="btn-icon right">{rightIcon}</span>}
        </>
    );

    if (link) {
        return (
            <Link to={link} className={className} aria-disabled={disabled}>
                {content}
            </Link>
        );
    }

    return (
        <button onClick={onClick} className={className} disabled={disabled}>
            {content}
        </button>
    );
};

export default Button;
